// extracted by mini-css-extract-plugin
export default {"createTeamGroupDescription":"eGfD3zWESR1UFyc7X18K","tableRowActions":"B7Hq9jTybKe0BhCJ8VG4"};